<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <profile-update :id="id"/>
    <actor-role-index
      :filtering="actor_filter"
      :refresh="refresh"
      @refreshed="refreshed"
    >
    </actor-role-index>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProfileUpdate from './ProfileUpdate.vue'
import ActorRoleIndex from './ActorRoleIndex.vue'

export default {
  components: {
    VuexBreadcrumb,
    ProfileUpdate,
    ActorRoleIndex
  },
  props: {
    id: {
      Type: String
    }
  },
  data() {
    return {
      actor_filter: {
        profile_ids: this.id
      },
      refresh: false
    }
  },
  methods: {
    refreshed() {
      this.refresh = false
    }
  }
}
</script>